export const getWindow = () => {
  if (typeof window === 'undefined') return undefined;
  return window;
};
